import { Stack } from "@mui/material";
import { DeleteConfirmModal } from "components/DeleteConfirmModal";
import { useTranslation } from "react-i18next";

import { useTechnicalDataScenarioContext } from "../context/TechnicalDataScenarioProvider";
import { useScenarioSelectorActions } from "../hooks/useScenarioSelectorActions";
import { ScenarioAddCard } from "./ScenarioAddCard";
import { ScenarioCard } from "./ScenarioCard";
import { ScenarioFormModal } from "./ScenarioFormModal";

export const ScenarioSelector = () => {
  const { t } = useTranslation();
  const { activeScenarioId, isLoading, scenarios } = useTechnicalDataScenarioContext();
  const {
    closeDeleteConfirm,
    closeModal,
    confirmDelete,
    handleDelete,
    handleSubmit,
    modalInitialState,
    modalState,
    openAddModal,
    openEditModal,
    scenarioToDelete,
    setActiveScenarioId,
  } = useScenarioSelectorActions();

  return (
    <>
      <section className="w-full pb-6">
        <Stack className="w-full flex-nowrap items-stretch gap-3 overflow-x-auto">
          {isLoading && scenarios.length === 0 ? (
            <p className="font-ds-body-regular-md text-lds-foreground-muted">{t("general.loadingDataPleaseWait")}</p>
          ) : null}
          {scenarios.map((scenario) => (
            <ScenarioCard
              isActive={scenario.id === activeScenarioId}
              key={scenario.id}
              onDelete={() => handleDelete(scenario)}
              onEdit={() => openEditModal(scenario)}
              onSelect={() => setActiveScenarioId(scenario.id)}
              scenario={scenario}
            />
          ))}
          <ScenarioAddCard onClick={openAddModal} />
        </Stack>
      </section>
      {modalState ? (
        <ScenarioFormModal
          initialFormState={modalInitialState}
          mode={modalState.mode}
          onClose={closeModal}
          onSubmit={handleSubmit}
          open={Boolean(modalState)}
        />
      ) : null}
      <DeleteConfirmModal
        onCancel={closeDeleteConfirm}
        onConfirm={confirmDelete}
        open={Boolean(scenarioToDelete)}
      />
    </>
  );
};
